import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class UploadErrorsService {
  constructor(private dataService: DataService) {
  }
  url = environment.api_base_url;


  getUploadErrorsList(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "dataentry/upload/errors").subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getFileErrorsList(fileName: string): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "dataentry/upload/errors/" + fileName).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  fixErrors(data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "dataentry/upload/errors/fix", data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }




}